'use client';

import { AlertTriangle, CheckCircle2, XCircle } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

export type StatusIconVariant = 'success' | 'warning' | 'error';

interface StatusIconProps {
  variant: StatusIconVariant;
  message: string;
  ariaLabel: string;
}

export function StatusIcon({ variant, message, ariaLabel }: StatusIconProps) {
  const icon =
    variant === 'success' ? (
      <CheckCircle2 className="h-4 w-4 text-green-600" />
    ) : variant === 'warning' ? (
      <AlertTriangle className="h-4 w-4 text-amber-500" />
    ) : (
      <XCircle className="h-4 w-4 text-red-600" />
    );

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="flex shrink-0 items-center rounded p-1 hover:bg-slate-50"
          aria-label={ariaLabel}
        >
          {icon}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-2 text-xs">{message}</PopoverContent>
    </Popover>
  );
}

